export default ({
    current,
    max
}, interpolateFunc) => {
    const value = current / max // as decimal
    if (interpolateFunc) return interpolateFunc(value)
    return value
}
